import { MoodProps } from '../typings/mood'

//Action Types
export const SET_MOOD_DATA = "setMoodsData";
export const RESET_MOOD_DATA = "resetMoodsData";

//Action creators
export const setMoodData = (data: MoodProps[]) => ({
    type: SET_MOOD_DATA,
    data
});

export const resetMoodData = () => ({
    type: RESET_MOOD_DATA,
});

const initialState: MoodProps[] = [];


//Reducer


export default function reducer(state = initialState, action: any) {
    switch (action.type) {
        case SET_MOOD_DATA:
            return [...state, ...action.data];
        case RESET_MOOD_DATA:
            return [...initialState];
        default:
            return state;
    }
}